var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9925 0C13.5667 0 15 1.513 15 4.1055V12.886C15 15.521 13.5667 17 10.9925 17H4.00833C1.475 17 0 15.521 0 12.886V4.1055C0 1.513 1.475 0 4.00833 0H10.9925ZM4.23333 11.679C3.98333 11.6535 3.74167 11.7725 3.60833 11.9935C3.475 12.206 3.475 12.4865 3.60833 12.7075C3.74167 12.92 3.98333 13.0475 4.23333 13.0135H10.7667C11.0992 12.9795 11.35 12.6897 11.35 12.3505C11.35 12.002 11.0992 11.713 10.7667 11.679H4.23333ZM10.7667 7.80215H4.23333C3.87417 7.80215 3.58333 8.1005 3.58333 8.466C3.58333 8.8315 3.87417 9.129 4.23333 9.129H10.7667C11.125 9.129 11.4167 8.8315 11.4167 8.466C11.4167 8.1005 11.125 7.80215 10.7667 7.80215ZM6.72417 3.9525H4.23333V3.961C3.87417 3.961 3.58333 4.2585 3.58333 4.624C3.58333 4.9895 3.87417 5.287 4.23333 5.287H6.72417C7.08333 5.287 7.375 4.9895 7.375 4.61465C7.375 4.25 7.08333 3.9525 6.72417 3.9525Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgram);
export default __webpack_public_path__ + "static/media/program.499729e22cebb76e529282689e165f1b.svg";
export { ForwardRef as ReactComponent };